/*
 * Hoysala Coffee & Spices — retail storefront runtime.
 *
 * Three small behaviours only: the gallery thumbnails, the quantity steppers,
 * and the price swap when a variant is chosen. Everything else on these pages
 * is a real form post to Shopify (/cart/add, /cart), so the shop keeps working
 * with JavaScript disabled — the steppers are progressive enhancement over a
 * plain number input, and the thumbnails degrade to a strip of images.
 *
 * Loaded alongside site.js, which supplies the shared header behaviour (the
 * phone menu, scroll reveals). Kept separate so the 144 replica pages never
 * carry the shop's code.
 */
(() => {
  'use strict';

  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ------------------------------------------------------------ 1. gallery */
  (() => {
    const main = document.querySelector('[data-store-main]');
    const thumbs = $$('[data-store-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-store-thumb');
        if (!src) return;
        main.src = src;
        const img = thumb.querySelector('img');
        if (img && img.alt) main.alt = img.alt;
        thumbs.forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
      });
    });
  })();

  /* ------------------------------------------------------------ 2. steppers */
  // Scoped to the .store-qty the button sits in, so the cart page's one-per-line
  // steppers each drive their own input rather than the first on the page.
  $$('[data-store-qty]').forEach((button) => {
    button.addEventListener('click', () => {
      const box = button.closest('.store-qty');
      const input = box && box.querySelector('input');
      if (!input) return;
      const step = Number(button.getAttribute('data-store-qty')) || 0;
      const min = Number(input.getAttribute('min') || 0);
      const next = Math.max(min, (Number(input.value) || 0) + step);
      if (next === Number(input.value)) return;
      input.value = String(next);
      // The cart form reads updates[] on submit, but a listener elsewhere may
      // care; dispatch so this looks like a real edit either way.
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ------------------------------------------------------------ 3. price */
  // Every product currently prices all its variants the same, so this normally
  // changes nothing. It is here so that setting one variant dearer in the admin
  // shows up on the page instead of quietly disagreeing with the cart.
  (() => {
    const price = document.querySelector('[data-store-price]');
    const radios = $$('input[name="id"][data-store-variant-price]');
    if (!price || !radios.length) return;

    const paint = () => {
      const checked = radios.find((r) => r.checked);
      const value = checked && checked.getAttribute('data-store-variant-price');
      if (value) price.textContent = value;
    };

    radios.forEach((r) => r.addEventListener('change', paint));
    paint();
  })();
})();
